import { IBillingInfo } from '@global/types/types';
import { OrderPriceType } from '@global/utils/orderUtils';
import { IShippingInfo } from './components/ShippingInformation/types';

export const initBillingInfo: IBillingInfo = {
  name: '',
  tel: '',
  addressOne: '',
  addressTwo: '',
  city: '',
  state: '',
  zip: '',
  country: {
    name: '',
    numericCode: '',
    iso2Code: '',
  },
};

export const initShippingInfo: IShippingInfo = {
  firstName: '',
  lastName: '',
  phone: '',
  addressOne: '',
  addressTwo: '',
  city: '',
  state: '',
  zip: '',
  country: {
    name: '',
    numericCode: '',
    iso2Code: '',
  },
};

export const initOrderPrice: OrderPriceType = {
  total: { value: 0, code: '' },
  tax: { value: 0, code: '' },
  price: { value: 0, code: '' },
  discount: { value: 0, code: '' },
  subtotal: { value: 0, code: '' },
};

export const CHECKOUT_ACCOUNT_STEP = 1;
export const CHECKOUT_SHIPPING_STEP = 2;
export const CHECKOUT_SCHOOL_STEP = 3;
export const CHECKOUT_PAYMENT_AND_BILLING_STEP = 4;
export const CHECKOUT_REVIEW_STEP = 5;

export const SHIPPING_REGION = 'Americas';
export const SHIPPING_US_REGION_RESTRICTED_COUNTRIES = ['CA'];
export const BILLING_US_REGION_RESTRICTED_COUNTRIES = ['CA'];
